import { LightMode, ModalContent, ModalContentProps } from '@chakra-ui/react'
import { ElementRef, Ref } from 'react'

interface LightModeModalContentProps extends ModalContentProps {
  ref?: Ref<ElementRef<typeof ModalContent>>
}

/** Light shell + tokens on a paper dialog while the app is in dark mode. */
export const LightModeModalContent = ({
  ref,
  ...props
}: LightModeModalContentProps) => (
  <LightMode>
    <ModalContent ref={ref} {...props} />
  </LightMode>
)

LightModeModalContent.displayName = 'LightModeModalContent'
